import { SaveFormButton } from "../form/SaveFormButton";
import { HeaderButtonAreaPortal } from "./HeaderButtonAreaPortal";

export const HeaderSaveFormButton: React.FC = () => (
  <HeaderButtonAreaPortal>
    <SaveFormButton />
  </HeaderButtonAreaPortal>
);
